import { Button } from '../../../../../../components/Button'
import { LineData } from '../../../../../../components/LineData'
import { type ExpertDomain } from '../../../../../../types/domain/expert-domain'

interface Props {
  data?: ExpertDomain
  edit: () => void
}

export const BankData = ({ data, edit }: Props) => {
  return (
    <div>
      <LineData label="Banco" text={data?.bankData?.bank} />

      <div className="flex flex-col md:flex-row md:gap-14 ">
        <LineData label="Agência" text={data?.bankData?.bankBranch} />
        <LineData
          label="Conta Corrente"
          text={data?.bankData?.currentAccount}
        />
      </div>

      <Button variant="outline" className="mt-10" onClick={edit}>
        Editar
      </Button>
    </div>
  )
}
